export default "__VITE_ASSET__NtdfWa0Y__"